module.exports = __webpack_public_path__ + "img/birsdaybutton.6e45c8a6.png";